"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n"], ["\n    color: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputErrorPanel = _styledComponents2.default.span(_templateObject, function (props) {
    return props.theme.input.error.color;
});

var InputError = function InputError(props) {
    if (!props.error) {
        return null;
    }

    return _react2.default.createElement(
        InputErrorPanel,
        null,
        props.error
    );
};

InputError.displayName = "InputError";

InputError.propTypes = {
    error: _propTypes2.default.string
};

InputError.defaultProps = {
    error: ''
};

exports.default = InputError;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/inputError.js
// module id = 42
// module chunks = 95715928098905 168707334958949